require('./js/jquery-global.js');
import select2 from 'select2';
select2($);
require('./js/jquery-template.js');
require('./js/scripts.js');

import './sass/styles.scss';